import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsInvestmentCreation from "../creation-inner-pages/tms-investment-creation";
import TmsFdrInvestmentList from "../created-inner-pages/fdr-investment-list";

const InvestmentIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Investment Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsFdrInvestmentList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Investment Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsInvestmentCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default InvestmentIndex;
